var _rect, _path, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTpIconUnscored = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F2F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2998 41.9981H18.3249L18.3262 37.4597C18.1099 37.8922 17.4179 38.887 16.3799 39.406C15.0824 40.0547 14.4337 40.0547 13.1362 38.7572C12.0982 37.7192 11.4062 33.9998 11.19 32.2698H7.94623C6.90824 32.2698 6.21625 31.4048 6 30.9723C6.21625 30.3236 6.90824 29.1558 7.94623 29.6748C8.98423 30.1938 9.67622 29.8911 9.89247 29.6748C9.67582 29.8911 9.11277 30.0635 8.59377 29.0232C7.94503 27.7228 9.89126 29.0232 10.54 29.0232C11.059 29.0232 12.4862 29.8901 13.135 30.3236L15.0812 34.216C15.0812 30.0641 19.4062 28.1595 21.5687 27.7262C21.5699 27.7292 22.8662 27.2072 28.0561 27.7262C33.2461 28.2452 34.9761 32.7 35.1923 34.8624C35.8411 32.916 37.5278 29.0232 39.0848 29.0232C41.031 29.0232 41.6798 28.3744 41.6798 29.0232C41.6798 29.6719 39.7335 29.6719 40.3823 29.6719H42.9772C44.9235 29.6719 43.626 31.6181 42.3285 32.2669C41.2905 32.7859 39.7335 32.4831 39.0848 32.2669C39.6038 33.3049 38.436 37.0244 37.7873 38.7543C37.3548 39.1868 36.2303 40.0518 35.1923 40.0518C34.1543 40.0518 32.1648 38.3218 31.2998 37.4569V41.9981Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.364589
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 17,
    rx: 2.02998,
    fill: "#DEDEF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.03906,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#A3A3D9",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12.0391,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#A3A3D9",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16.0391,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#A3A3D9",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3431 20.8945H22.2706C21.7642 20.8945 21.3536 21.3051 21.3536 21.8115C21.3536 22.318 21.7642 22.7285 22.2706 22.7285H22.3431C22.8495 22.7285 23.2601 22.318 23.2601 21.8115C23.2601 21.3051 22.8495 20.8945 22.3431 20.8945Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.242123,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8499 24.1815C28.056 22.7052 28.0562 21.4539 27.8456 19.9365C27.688 18.8012 26.6793 18 25.5331 18H24.7895C23.5455 18 22.4942 18.9427 22.4027 20.1833C22.2977 21.6082 22.2732 22.7839 22.3624 24.0399C22.4472 25.2341 23.483 26.1083 24.6802 26.1083H25.5422C26.6843 26.1083 27.6919 25.3126 27.8499 24.1815Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.242123,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4352 20.7031H28.3627C27.8563 20.7031 27.4457 21.1137 27.4457 21.6201C27.4457 22.1266 27.8563 22.5371 28.3627 22.5371H28.4352C28.9416 22.5371 29.3522 22.1266 29.3522 21.6201C29.3522 21.1137 28.9416 20.7031 28.4352 20.7031Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.242123,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9526 17.5195C13.5051 17.5195 13.9535 17.9671 13.9536 18.5195C13.9536 19.0721 13.5052 19.5205 12.9526 19.5205C12.4002 19.5204 11.9526 19.072 11.9526 18.5195C11.9527 17.9671 12.4002 17.5196 12.9526 17.5195Z",
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.28843
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9417 7.80859C12.9666 7.8086 12.9917 7.80817 13.0168 7.80859C14.9491 7.84247 16.5101 9.17604 16.6077 10.8057C16.6596 11.675 16.3088 12.5042 15.6106 13.1416C15.1806 13.5341 14.6392 13.8242 14.0471 13.9863L13.9417 14.0146V15.249C13.9415 15.6986 13.5132 16.0967 12.9407 16.0967C12.3683 16.0966 11.9408 15.6985 11.9407 15.249V13.2861C11.9409 12.8367 12.3683 12.4386 12.9407 12.4385C13.3962 12.4385 13.8248 12.2803 14.1448 11.9883C14.4655 11.6955 14.6335 11.305 14.6086 10.8906C14.5861 10.5168 14.3997 10.1703 14.093 9.91309C13.7863 9.65586 13.3892 9.51218 12.9758 9.50488C12.1457 9.49064 11.4077 10.0153 11.2874 10.7627C11.2763 10.8314 11.2708 10.9018 11.2708 10.9717C11.2706 11.4212 10.8423 11.8193 10.2698 11.8193C9.69738 11.8193 9.26997 11.4212 9.26978 10.9717C9.26978 10.8256 9.28079 10.6781 9.30396 10.5342C9.55344 8.98449 11.098 7.80859 12.9417 7.80859Z",
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.28843
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTpIconUnscored);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tp_icon_unscored.9a6d7c60135160fad1929141e8e848ad.svg";